import { Box } from "@mui/material";
import { GoogleIcon, YandexIcon, GisIcon, BankiruIcon } from "./index";

interface IProps {
	type: string;
}

export const GeosrviceIcon = ({ type }: IProps) => {
	switch (type) {
		case "google":
			return <GoogleIcon />;
		case "yandex":
			return <YandexIcon />;
		case "2gis":
			return <GisIcon />;
		case "bankiru":
			return <BankiruIcon />;
		default:
			return <Box />;
	}
};
